import { counterDate, eventTimeFormat } from '@utils/time';
import { AddressText, DateText, EventCounterBody } from './styles';

import { getLanguage } from '@store/slices/configSlice';
import { getEventDetails } from '@store/slices/eventSlice';
import { useTabletWidth } from '@utils/hooks';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useTheme } from 'styled-components';
import Icon from '@components/Icon';

dayjs.extend(relativeTime);
dayjs.extend(duration);

const EventCounter = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const language = useSelector(getLanguage);
  const sluggedEvent = useSelector(getEventDetails)?.[0];
  const isTablet = useTabletWidth();

  const startDateCounter = useMemo(() => {
    return counterDate(sluggedEvent?.start_date);
  }, [sluggedEvent?.start_date]);

  if (isTablet) return null;

  return (
    <EventCounterBody color={sluggedEvent?.design?.secondaryThemeColor}>
      <AddressText>
        {`${eventTimeFormat(
          sluggedEvent?.start_date ?? '',
          sluggedEvent?.end_date ?? '',
          language
        )}
            ${sluggedEvent?.location?.name ? ` | ${sluggedEvent?.location?.name}` : ''}`}
      </AddressText>

      <DateText>
        {startDateCounter && (
          <div style={{ display: 'flex', flexDirection: 'row', gap: '0.5rem' }}>
            <Icon
              indentLess
              name="event-pages_calendar"
              color={theme.color.white}
            />
            {`${t('still')} ${startDateCounter}`}
          </div>
        )}
      </DateText>
    </EventCounterBody>
  );
};

export default EventCounter;
